<div class="kpmg-logo-container">
  <a routerLink="">
    <img class="kpmg-logo" alt="KPMG Logo" src="assets/kpmgLogo.png" />
  </a>
</div>
<div class="navbar-links">
  @for (item of menu; track item) { @if ((!item.admin || userInfo.isAdmin) &&
  (item.visible == null || item.visible())) {
  <a
    class="navbar-link"
    [ngClass]="item.className"
    routerLink="{{ item.routerLink }}"
    routerLinkActive="active"
    [queryParams]="item.queryParams"
    [attr.data-test-ref]="item.className"
  >
    <span class="nav-icon"
      >@if (item.semanticUiIcon) {
      <i [ngClass]="item.semanticUiIcon"></i>
      }</span
    >
    <span class="nav-label">{{ item.label }}</span>
  </a>
  } }
</div>
<div class="bottom-part">
  <app-report></app-report>
  <div class="profile-icon"></div>
  <div class="signed-in-as">
    <div>{{ userInfo.firstName }}</div>
    <div>{{ userInfo.lastName }}</div>
  </div>
  <div class="language">
    <div class="ui search selection dropdown" #languageDropDown>
      <input class="search" autocomplete="off" />
      <div class="text"></div>
      <div class="menu"></div>
      <i class="chevron down icon"></i>
    </div>
    <input type="hidden" [formControl]="language" />
  </div>

  <div
    class="logout-button-container"
    [attr.data-test-ref]="'logout'"
    (click)="logout()"
  >
    {{ "logout" | transloco }}
  </div>
</div>
<div #overlay id="overlay-modal" class="ui tiny modal">
  <div class="content"></div>
</div>
